import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export function AssignStaffDialog({ open, onClose, title, perm, multi, current = [], endpoint, bodyFor, onSaved, testid }) {
  const [staff, setStaff] = useState(null);
  const [sel, setSel] = useState(new Set(current));
  const [saving, setSaving] = useState(false);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (!open) { return; }
    setSel(new Set(current));
    api.get("/assignable-staff", { params: { perm } }).then((r) => setStaff(r.data.staff)).catch(() => setStaff([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, perm]);
  const toggle = (id) => {
    const n = multi ? new Set(sel) : new Set();
    sel.has(id) ? n.delete(id) : n.add(id);
    setSel(n);
  };
  const save = async () => {
    setSaving(true);
    try { await api.put(endpoint, bodyFor([...sel])); toast.success("Assignment saved"); onSaved(); onClose(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not save"); }
    finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid={testid}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        {!staff ? <div className="py-8 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div> : (
          <div className="max-h-72 overflow-y-auto -mx-2">
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search staff…" data-testid={`${testid}-search`}
              className="mx-2 mb-2 w-[calc(100%-1rem)] h-9 rounded-full bg-slate-100 px-3 text-sm outline-none" />
            {staff.length === 0 && <p className="px-2 py-4 text-sm text-slate-500">No staff with the right permission in this company.</p>}
            {staff.filter((s) => !q || s.name.toLowerCase().includes(q.toLowerCase())).map((s) => (
              <label key={s.id} className="flex items-center gap-2.5 rounded-lg px-2 py-2 hover:bg-slate-50 cursor-pointer text-sm">
                <input type={multi ? "checkbox" : "radio"} checked={sel.has(s.id)} onChange={() => toggle(s.id)} className="accent-indigo-600" data-testid={`${testid}-opt-${s.id}`} />{s.name}
              </label>
            ))}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          {!multi && sel.size > 0 && <Button variant="ghost" onClick={() => setSel(new Set())} data-testid={`${testid}-clear`}>Unassign</Button>}
          <Button onClick={save} disabled={saving} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid={`${testid}-save`}>{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
